import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_return_tasks_by_targetLicensePlateIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { targetLicensePlateId: number }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.targetLicensePlateId)) {
      missingRequiredInParams.push('\'targetLicensePlateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_return_tasks_by_targetLicensePlateId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { targetLicensePlateId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ProjectId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.targetLicensePlateId)) {
      missingRequiredInParams.push('\'targetLicensePlateId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_return_tasks_by_targetLicensePlateId/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { targetLicensePlateId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualSourceShippingContainerId?: number, ProjectId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.targetLicensePlateId)) {
      missingRequiredInParams.push('\'targetLicensePlateId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_return_tasks_by_targetLicensePlateId/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      targetLicensePlateId: number    }) {
        if(isNil(inParams.targetLicensePlateId)) {
          return true; 
        }
      return false;
    }
}
